var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SALogo } from '../logo';
import { SALogos } from '../logo/logo.options';
var Header = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      align-items: center;\n      background-color: " + (theme === null || theme === void 0 ? void 0 : theme.color.primary.background) + ";\n      box-shadow: " + (theme === null || theme === void 0 ? void 0 : theme.shadow.elevation.level2) + ";\n      display: flex;\n      flex-direction: row;\n      height: 98px;\n      justify-content: space-between;\n      padding: 0 " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.large) + ";\n\n      .header-logo,\n      .header-logo-bug {\n        line-height: 0;\n      }\n\n      .header-logo {\n        display: block;\n      }\n\n      .header-logo-bug {\n        display: none;\n      }\n\n      @media only screen and (max-width: 600px) {\n        height: 70px;\n        padding: 0 " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n\n        .header-logo {\n          display: none;\n        }\n\n        .header-logo-bug {\n          display: block;\n        }\n      }\n    ";
});
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: transparent;\n  border: 0;\n  line-height: 0;\n  padding: 0;\n"], ["\n  background-color: transparent;\n  border: 0;\n  line-height: 0;\n  padding: 0;\n"])));
var Section = styled.section(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  line-height: 0;\n"], ["\n  line-height: 0;\n"])));
export function SAHeader(_a) {
    var children = _a.children, onClick = _a.onClick, removeBranding = _a.removeBranding, rest = __rest(_a, ["children", "onClick", "removeBranding"]);
    var content = children !== undefined ? children : ' ';
    var logoComponent = removeBranding ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-logo" },
            React.createElement(SALogo, { name: SALogos.noBrandingLogoWhite })),
        React.createElement("div", { className: "header-logo-bug" },
            React.createElement(SALogo, { name: SALogos.noBrandingLogoBugWhite })))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-logo" },
            React.createElement(SALogo, { name: SALogos.stateAutoLogoWhite })),
        React.createElement("div", { className: "header-logo-bug" },
            React.createElement(SALogo, { name: SALogos.stateAutoLogoBugWhite }))));
    var logo = onClick !== undefined ? (React.createElement(Button, { type: "button", onClick: function (e) { return onClick(e); } }, logoComponent)) : (logoComponent);
    return (React.createElement(Header, __assign({}, rest),
        logo,
        React.createElement(Section, null, content)));
}
SAHeader.defaultProps = {
    logoName: 'state-auto-logo-white',
    removeBranding: false,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=header.component.js.map